/** External dependencies */
import autosize from 'autosize';

export function forms() {
    jQuery(document).on('wsf-rendered', () => {
        const textareas = document.querySelectorAll('textarea');

        if (textareas) {
            autosize(textareas);
        }
    });
}
